import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ProfileHeader from './ProfileHeader';
import ProfileTabs from './ProfileTabs';
import ProfileTabContent from './ProfileTabContent';
import { TAB } from './tabs';

const ProfilePage = () => {
  const { slug } = useParams(); // URLからslugまたはpublic tokenを取得
  const { user: authUser } = useAuth(); // ログイン中ユーザー
  const [profileUser, setProfileUser] = useState(null);
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/users/${slug}`);
        const data = res.data;
        setProfileUser(data);
        const defaultTabs = {
          artist: TAB.UPCOMING,
          organizer: TAB.UPCOMING,
          venue: TAB.UPCOMING,
          buyer: TAB.PURCHASED,
        };
        setActiveTab(defaultTabs[data.role] || TAB.UPCOMING);
      } catch (error) {
        console.error('ユーザー取得エラー', error);
      }
    };

    fetchUser();
  }, [slug]);

  if (!profileUser) return <div>読み込み中...</div>;

  const isOwner = authUser?.id === profileUser.id;

  // buyerは常に本人以外は非表示
  if (!isOwner) {
    if (profileUser?.role === 'buyer') {
      return <div>このプロフィールは表示できません。</div>;
    }
    if (profileUser?.role === 'admin') {
      return <div>このプロフィールは表示できません。</div>;
    }
  }

  return (
    <div>
      <ProfileHeader user={profileUser} isOwner={isOwner} />
      <ProfileTabs
        userRole={profileUser.role}
        isOwner={isOwner}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <ProfileTabContent
        user={profileUser}
        isOwner={isOwner}
        activeTab={activeTab}
      />
    </div>
  );
};

export default ProfilePage;
